import React, { useContext } from "react";
import { observer } from "mobx-react";

import { TournamentOffer, getEventSortByFavorite, EventOffer } from "@gp/offer";
import { SportOfferContext, EventContext } from "@gp/components";

import { Event, EventOutright } from "@features/offer/desktop/event-row";

import { Sorter } from "@gp/utility";
import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";

export const TournamentEventsList = observer(
	function TournamentEventsList(props: { tournament: TournamentOffer }) {
		const sport = useContext(SportOfferContext);
		const favoritesStore = useContext(FavoritesStoreContext);
		const events =
			favoritesStore.userFavoriteEventsSet.size > 0
				? props.tournament.events.sort(
						Sorter.sort((a, b) => {
							return Sorter.sort(
								(a1: EventOffer, b1: EventOffer) =>
									getEventSortByFavorite(
										a1,
										b1,
										favoritesStore
									),

								"startTime"
							)(a, b);
						})
					)
				: props.tournament.events;
		return (
			<>
				{events.map((event, index) => (
					<EventContext.Provider key={event.id} value={event}>
						{sport.isOutright ? (
							<EventOutright />
						) : (
							<Event
								noSecondaryOffer={!event.isLive}
								showSecondaryOffer={event.isLive}
								isAlternate={index % 2 === 0}
							/>
						)}
					</EventContext.Provider>
				))}
			</>
		);
	}
);
